import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  dashboardorders: [],
  dashboardOrderStatus: [],
  dashboardProductCount: [],
  dashboardReviewCount: [],
  dashboardInquiryCount: [],
  dashboardCustomerCount: [],
  order: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    loadDashboardOrdersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDashboardOrdersSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.dashboardorders = action?.payload?.result;
    },
    loadDashboardOrdersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    // load status count
    loadDashboardOrdersStatusRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDashboardOrdersStatusSuccess(
      state,
      action: PayloadAction<{ result: any }>
    ) {
      state.loading = false;
      state.error = null;
      state.dashboardOrderStatus = action.payload.result;
    },
    loadDashboardOrdersStatusFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    //load product count
    loadDashboardProductCountRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDashboardProductCountSuccess(
      state,
      action: PayloadAction<{ result: any }>
    ) {
      state.loading = false;
      state.error = null;
      state.dashboardProductCount = action.payload.result;
    },
    loadDashboardProductCountFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    // review count
    loadDashboardReviewCountRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDashboardReviewCountSuccess(
      state,
      action: PayloadAction<{ result: any }>
    ) {
      state.loading = false;
      state.error = null;
      state.dashboardReviewCount = action.payload.result;
    },
    loadDashboardReviewCountFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    // inquiry count

    loadDashboardInquiryCountRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDashboardInquiryCountSuccess(
      state,
      action: PayloadAction<{ result: any }>
    ) {
      state.loading = false;
      state.error = null;
      state.dashboardInquiryCount = action.payload.result;
    },
    loadDashboardInquiryCountFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    //customer count
    loadDashboardCustomerCountRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDashboardCustomerCountSuccess(
      state,
      action: PayloadAction<{ result: any }>
    ) {
      state.loading = false;
      state.error = null;
      state.dashboardCustomerCount = action.payload.result;
    },
    loadDashboardCustomerCountFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadDashboardOrdersFail,
  loadDashboardOrdersRequested,
  loadDashboardOrdersSuccess,
  loadDashboardReviewCountFail,
  loadDashboardReviewCountSuccess,
  loadDashboardReviewCountRequested,
  loadDashboardProductCountFail,
  loadDashboardProductCountSuccess,
  loadDashboardProductCountRequested,
  loadDashboardOrdersStatusFail,
  loadDashboardOrdersStatusSuccess,
  loadDashboardOrdersStatusRequested,
  loadDashboardInquiryCountFail,
  loadDashboardInquiryCountSuccess,
  loadDashboardInquiryCountRequested,
  loadDashboardCustomerCountFail,
  loadDashboardCustomerCountRequested,
  loadDashboardCustomerCountSuccess,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
